import { api } from "../App";
import { SET_TV_PROGRAM_TYPE_LIST, SET_TV_PROGRAM_TYPE_LOADING } from "./types";




export const getTvProgramType = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_TV_PROGRAM_TYPE_LOADING, payload: true });
    const { data } = await api.get('/tv_program_type');
    dispatch({ type: SET_TV_PROGRAM_TYPE_LIST, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TV_PROGRAM_TYPE_LOADING, payload: false });
  }
}

export const createTvProgramType = (data) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_TV_PROGRAM_TYPE_LOADING, payload: true });
    await api.post('/tv_program_type', data);
    await dispatch(getTvProgramType())
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TV_PROGRAM_TYPE_LOADING, payload: false });
    return success
  }
}

export const updateTvProgramType = (data) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_TV_PROGRAM_TYPE_LOADING, payload: true });
    await api.put(`/tv_program_type/${data.id}`, data);
    await dispatch(getTvProgramType())
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TV_PROGRAM_TYPE_LOADING, payload: false });
    return success
  }
}

export const deleteTvProgramType = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_TV_PROGRAM_TYPE_LOADING, payload: true });
    await api.delete(`/tv_program_type/${id}`);
    await dispatch(getTvProgramType())
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TV_PROGRAM_TYPE_LOADING, payload: false });
  }
}